import { Users, Check } from "lucide-react";
import { editorColors as colors, fonts } from "../../styles/theme";

export default function EditorStatusBar({
  wordCount,
  segment,
  customEmails,
  segmentCounts,
  editor,
}) {
  // Estimate compiled email size (~2x body HTML for MJML wrapper + headers)
  const bodyLen = editor?.getHTML()?.length || 0;
  const estKb = Math.round((bodyLen * 2) / 1024);
  const gmailLimit = 102;
  const sizeColor =
    estKb > gmailLimit
      ? colors.danger
      : estKb > 80
        ? colors.warning
        : colors.textSecondary;

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "6px 16px",
        background: colors.bgCard,
        borderTop: `1px solid ${colors.border}`,
        fontSize: 12,
        color: colors.textSecondary,
        fontFamily: fonts.body,
        flexShrink: 0,
      }}
    >
      <div style={{ display: "flex", gap: 16, alignItems: "center" }}>
        <span>{wordCount} words</span>
        <span>~{Math.max(1, Math.ceil(wordCount / 200))} min read</span>
        <span style={{ display: "flex", alignItems: "center", gap: 4 }}>
          <Users size={11} />
          {segment === "custom" ? customEmails.length : segmentCounts[segment]} recipients
        </span>
      </div>
      <div style={{ display: "flex", gap: 12, alignItems: "center" }}>
        <span
          style={{
            display: "flex",
            alignItems: "center",
            gap: 4,
            color: sizeColor,
          }}
          title={
            estKb > 80
              ? "Gmail clips emails over 102KB"
              : "Estimated compiled email size"
          }
        >
          ~{estKb}KB
          {estKb > gmailLimit
            ? " — Gmail will clip!"
            : estKb > 80
              ? " — near Gmail limit"
              : ""}
        </span>
        <span
          style={{
            display: "flex",
            alignItems: "center",
            gap: 4,
            color: colors.success,
          }}
        >
          <Check size={11} /> SPF/DKIM/DMARC verified
        </span>
        <span>MJML email-safe</span>
      </div>
    </div>
  );
}
